/* Функции */
import {
  defineComponent, PropType, VNode,
} from 'vue'

/** Типы */
import { defaultProps, defaultStyles } from '@/components/VText/Types'

/* Стили */
import '@/components/VText/VTextHeading2/VTextHeading2.scss'

export default defineComponent({
  name: 'VTextHeading2',

  props: {
    ...defaultProps(),

    /** Тег */
    tag: {
      type: String as PropType<string>,
      default: 'h2',
    },
  },

  computed: {
    styles() {
      return {
        ...defaultStyles.call(this),
      }
    },
  },

  render(): VNode {
    const nameComponent = this.tag

    return (
      <nameComponent onClick={this.onClick} class={'text text-h2'} style={this.styles}>
        {this.$slots.default?.()}
      </nameComponent>
    )
  },
})
